import usePracticeVoiceEnabled from "hooks/use-practice-voice-enabled.hook";
import useUserRoles from "hooks/use-user-roles.hook";

import type { VoiceSeatNoticeCase } from "./voice-seat-notice.copy";

export default function useVoiceSeatNoticeAudience(): VoiceSeatNoticeCase {
  const { isSwitchedSession, isSunoAdmin, isAdminOrBusinessOwner } =
    useUserRoles();
  const isPracticeVoiceEnabled = usePracticeVoiceEnabled();
  if (isSwitchedSession) return "switched";
  // Voice Setup is where Suno staff add a seat, or set a practice up.
  if (isSunoAdmin) return "suno";
  if (!isPracticeVoiceEnabled) return "practiceWithoutVoice";
  if (isAdminOrBusinessOwner) return "admin";
  return "staff";
}
